export default {
  name: 'messages',
  messages: 'messages',
  leadMessages: 'leadMessages',
  fetchId: 'fetchId'
};
